export const RAMADAN_CAMPAIGN_2025_PROD = 'ramadan_campaign_2025_PROD'
export const RAMADAN_CAMPAIGN_2025_DEV = 'ramadan_campaign_2025_DEV'
export const OOREDOO_OFFER = 'qatar_travel_ooredoo_offer'
export const GEORGIA_WINTER_COVER = 'qatar_travel_georgia_winter_cover'
export const TRAVEL_HOME_OFFER = 'travel_home_offer'
export const QATAR_BOOKING_OFFER = 'travel_qatar_booking_offer'

export const FEATURES = [
  RAMADAN_CAMPAIGN_2025_PROD,
  RAMADAN_CAMPAIGN_2025_DEV,
  OOREDOO_OFFER,
  GEORGIA_WINTER_COVER,
  TRAVEL_HOME_OFFER,
  QATAR_BOOKING_OFFER,
]
export const RAMADAN_BANNER_PAGES = ['outbound-select-plans', 'outbound-quote']
